const MediaGalleryModal = ({
  id = "mediaModal",
  title = "Media Library",
  media = [],
  selectedIds = [],
  onCheckboxChange,
  onSubmit,
  onLoadMore,
  hasMore,
  loading,
  BASE_URL,
}) => {
  return (
    <div className="modal fade" id={id} tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
            />
          </div>

          {/* Body */}
          <div className="modal-body">
            <div className="row">
              {media.map((item, index) => {
                const isChecked = selectedIds.includes(item.id);

                let mediaSrc =
                  item.thumbnail_url || item.media_url || item.file_path;

                if (mediaSrc && !mediaSrc.startsWith("http")) {
                  mediaSrc = `${BASE_URL}${mediaSrc}`;
                }

                const isVideo = item.media_type === "video";

                return (
                  <div className="col-md-3 mb-4" key={index}>
                    <div className="card h-100">
                      <div className="position-relative">
                        {isVideo ? (
                          <video
                            src={mediaSrc}
                            className="card-img-top"
                            style={{
                              height: "160px",
                              objectFit: "cover",
                            }}
                            muted
                          />
                        ) : (
                          <img
                            src={mediaSrc}
                            alt={item.media_name}
                            className="card-img-top"
                            style={{
                              height: "160px",
                              objectFit: "cover",
                            }}
                          />
                        )}

                        <div className="position-absolute top-0 end-0 p-2">
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => onCheckboxChange(item)}
                          />
                        </div>
                      </div>

                      <div className="card-body p-2 text-center">
                        <small className="text-muted">{item.media_name}</small>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {hasMore && (
              <div className="text-center mt-3 mb-3">
                <button
                  className="btn theme-button btn-round btn-sm"
                  onClick={onLoadMore}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Load More"}
                </button>
              </div>
            )}

            <div className="modal-footer">
              <button
                type="button"
                className="btn theme-secondary-button btn-round btn-sm"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn theme-button btn-round btn-sm"
                onClick={onSubmit}
              >
                Select Media
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaGalleryModal;
